import React, { useState, useEffect } from 'react'
import {
    Card, Col, Container, NavLink, Nav, NavItem, TabContent, TabPane, Input,
    Offcanvas, OffcanvasBody, OffcanvasHeader, Progress
} from 'reactstrap'
import { Chrono } from "react-chrono";

export const LabRequestCanvasStatus = ({labRequest, setShowCanvas, showCanvas}) => {

  const closeCanvas = () =>{

  }

  const samplesPctg = labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de muestras')?.percentage
  const testPctg = labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de ensayos')?.percentage 
  const reportPctg = labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de informes')?.percentage
  const resultPctg = labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de resultados')?.percentage
  const surveyPctg =  labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de encuesta')?.percentage

  const samplesStatus = labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de muestras')?.trackingStatus ?? ''
  const testStatus = labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de ensayos')?.trackingStatus ?? ''
  const reportStatus = labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de informes')?.trackingStatus ?? ''
  const resultStatus = labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de resultados')?.trackingStatus ?? ''
  const surveyStatus =  labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de encuesta')?.trackingStatus ?? ''
  
//   console.log('LabRequest:', labRequest)
//   console.log('Càlculo:', (samplesPctg+testPctg+reportPctg)/3)
//   console.log('Valores:', samplesPctg,testPctg,reportPctg, resultPctg, surveyPctg)

  const total = (samplesPctg + testPctg + reportPctg + resultPctg + surveyPctg)/5

  const tlData = [
    {
        title: `${Math.floor((samplesPctg+testPctg+reportPctg)/3)}%`,
        cardTitle: "Solicitud de Análisis",
    },
    {
        title: `${resultPctg}%`,
        cardTitle: "Entrega de Resultados",
    },
    {
        title: `${surveyPctg}%`,
        cardTitle: "Encuesta de Satisfacción",
    },
  ]

  return(
    <Offcanvas
        isOpen={showCanvas}
        onClosed={closeCanvas}
        direction="end"
        toggle={() => { setShowCanvas(!showCanvas) }}
    >
        <OffcanvasHeader className='text-primary' toggle={() => { setShowCanvas(!showCanvas) }}>
            <div className='d-flex m-0 p-0'>
                <label><h5 className='text-primary m-0 ps-4'>Etapa de la Gestión de Servicios | {labRequest?.code ?? ''}</h5></label>
            </div>
            <hr style={{ background: 'linear-gradient(to right, #94C12E,#04BBF1 ,#1D4370)', height: 4 }} />
        </OffcanvasHeader>
        <OffcanvasBody className='p-0'>
          <div className='text-center p-2'>
              <div className='row text-center'>
                  <label><h5 className='text-warning m-0'>Avance {` ${total}`}%</h5></label>
              </div>
              <div className='row'>
                  <Progress
                      animated
                      className="my-3 text-warning"
                      value={total}
                  />
              </div>
          </div>

          <Chrono
              items={tlData}
              mode="VERTICAL_ALTERNATING"
              focusActiveItemOnLoad
              activeItemIndex={0}
              allowDynamicUpdate={false}
              disableNavOnKey={true}
          >
              <div className="chrono-icons">
                  <i className="mdi mdi-24px mdi-cog-outline p-3"></i>
                  <i className="mdi mdi-24px mdi-clock-outline p-3"></i>
                  <i className="mdi mdi-24px mdi-clock-outline p-3"></i>
              </div>
              <div>
                  <ul>
                    {
                        (samplesStatus === 'Autorizado') ?
                        <li>Validación de Muestras:{' '}<div className='text-success border border-success rounded-pill text-center'>{samplesStatus}</div></li> :
                        (samplesStatus === 'Rechazado' ) ?
                        <li>Validación de Muestras:{' '}<div className='text-danger border border-danger rounded-pill text-center'>{samplesStatus}</div></li> :

                        <li>Validación de Muestras:{' '}<div className='text-warning border border-warning rounded-pill text-center'>{samplesStatus}</div></li> 
                    }
                    {
                        (testStatus === 'Autorizado') ?
                        <li>Validación de Ensayos:{' '}<div className='text-success border border-success rounded-pill text-center'>{testStatus}</div></li> :
                        (testStatus === 'Rechazado' ) ?
                        <li>Validación de Ensayos:{' '}<div className='text-danger border border-danger rounded-pill text-center'>{testStatus}</div></li> :

                        <li>Validación de Ensayos:{' '}<div className='text-warning border border-warning rounded-pill text-center'>{testStatus}</div></li> 
                    }
                    {
                        (reportStatus === 'Autorizado') ?
                        <li>Validación de Informes:{' '}<div className='text-success border border-success rounded-pill text-center'>{reportStatus}</div></li> :
                        (reportStatus === 'Rechazado' ) ?
                        <li>Validación de Informes:{' '}<div className='text-danger border border-danger rounded-pill text-center'>{reportStatus}</div></li> :

                        <li>Validación de Informes:{' '}<div className='text-warning border border-warning rounded-pill text-center'>{reportStatus}</div></li> 
                    }

                  </ul>
              </div>
              <div>
                  <ul>
                    {
                        (resultStatus === 'Autorizado') ?
                        <li>Validación de Resultados:{' '}<div className='text-success border border-success rounded-pill text-center'>{resultStatus}</div></li> :
                        (resultStatus === 'Rechazado' ) ?
                        <li>Validación de Resultados:{' '}<div className='text-danger border border-danger rounded-pill text-center'>{resultStatus}</div></li> :

                        <li>Validación de Resultados:{' '}<div className='text-warning border border-warning rounded-pill text-center'>{resultStatus}</div></li> 
                    }
                  </ul>
              </div>
              <div>
                  <ul>
                    {
                        (surveyStatus === 'Encuesta Realizada' || surveyStatus === 'Concluido' ) ?
                        <li>Validación de Encuesta:{' '}<div className='text-success border border-success rounded-pill text-center'>{surveyStatus}</div></li> :
                        (surveyStatus === 'Bloqueado' ) ?
                        <li>Validación de Encuesta:{' '}<div className='text-danger border border-danger rounded-pill text-center'>{surveyStatus}</div></li> :

                        <li>Validación de Encuesta:{' '}<div className='text-warning border border-warning rounded-pill text-center'>{surveyStatus}</div></li> 
                    }
                      
                  </ul>
              </div>
            </Chrono>
        </OffcanvasBody>
    </Offcanvas>
  )
}